import React from 'react'

export default function ButtonRemovePicture({
  onClick = () => { }
}) {
  return (
    <button onClick={onClick} className='profile-picture-selector__btn-remove-picture'>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M4 4L12 12" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  )
}
